import { render, staticRenderFns } from "./VitalSignsPanel.vue?vue&type=template&id=76b72e0b&"
import script from "./VitalSignsPanel.vue?vue&type=script&lang=js&"
export * from "./VitalSignsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports